var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c7d2fe",
    strokeWidth: 0.5,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 800,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 800,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 800,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 800,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 250,
    x2: 800,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 800,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 350,
    x2: 800,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 400
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 320 L100 280 L200 300 L300 250 L400 260 L500 200 L600 220 L700 180 L800 210",
    stroke: "#2563eb",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBackground);
export default __webpack_public_path__ + "static/media/ChartBackground.f4efa259bbeb6c8f0e59fd2f1481be99.svg";
export { ForwardRef as ReactComponent };